module.exports = __webpack_public_path__ + "img/zhiqing.54f69d8c.png";